import styled from 'styled-components';
import { Card, CardContent, CardHeader, CardTitle } from 'components';

export const Wrapper = styled.div.attrs({
  className: 'container mx-auto max-w-6xl px-6 pt-6 pb-32',
})``;

export const DevicesCard = styled(Card).attrs({
  className: 'gap-2 rounded-md py-0 shadow-xs',
})``;

export const DevicesCardHeader = styled(CardHeader).attrs({
  className: 'px-4 pt-3',
})``;

export const DevicesCardContent = styled(CardContent).attrs({
  className: 'space-y-4 px-4 pb-4',
})``;

export const StyledCardTitle = styled(CardTitle).attrs({
  className: 'text-base font-semibold',
})``;
